import React from 'react';
import ReactCardFlip from 'react-card-flip';

interface FlipCardProps {
  frontComponent: React.ReactNode;
  backComponent: React.ReactNode;
  flipDirection?: 'horizontal' | 'vertical';
  className?: string;
  frontStyle?: any;
  backStyle?: any;
  containerStyle?: any;
  isFlipped?: boolean;
}

export const FlipCard: React.FC<FlipCardProps> = ({
  frontComponent,
  backComponent,
  flipDirection = 'horizontal',
  className,
  isFlipped = false,
  containerStyle,
  frontStyle,
  backStyle,
}) => {
  return (
    <div className={className}>
      <ReactCardFlip
        isFlipped={isFlipped}
        flipDirection={flipDirection}
        containerStyle={containerStyle}
        cardStyles={{ front: frontStyle, back: backStyle }}
      >
        <div key="front" className="h-full">
          {frontComponent}
        </div>
        <div key="back" className="h-full">
          {backComponent}
        </div>
      </ReactCardFlip>
    </div>
  );
};
